import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./authAlertBox.css";
import Button from "../ThemeButton/ThemeButton";
import PropTypes from "prop-types";
import InputComponent from "../InputComponent/InputComponent";

const AuthAlertBox = ({
  show,
  setShow,
  alertMessage,
  popImage,
  handleSubmitData,
  modalTitle = "Are you sure?",

  handleCancelClick,
  buttonSubmitText,
  onChangeOfInput,
  valueOfInput,
}) => {
  return (
    <div>
      <Modal show={show} className="alertBoxModal">
        <div className="contentContainerConfirmAlert">
          <Modal.Header closeButton>
            <Modal.Title>{modalTitle}</Modal.Title>
            <div className="modalBody">{alertMessage}</div>
          </Modal.Header>
          <div className="imgTitles">
            <img src={popImage} alt="icon" />
          </div>
          <InputComponent
            placeholder={"Enter Code"}
            onChange={onChangeOfInput}
            value={valueOfInput}
          />
          <Modal.Footer>
            <div className="buttonOk">
              <div className="cancelBtns">
                <Button value="Cancel" onClick={handleCancelClick}></Button>
              </div>
              <Button
                value={buttonSubmitText}
                onClick={handleSubmitData}
              ></Button>
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  );
};

export default AuthAlertBox;
